import {
  Box,
  Typography,
  TextField,
  Tab,
  Tabs,
  ThemeProvider,
  InputLabel,
} from '@mui/material'
import { IconButton } from '@mui/material'
import RefreshIcon from '@mui/icons-material/Refresh'

import PropTypes from 'prop-types'

import React from "react"
import { useState, useEffect } from "react"
import { useTheme, createTheme } from '@mui/material'
import { useParams } from 'react-router-dom'
import Header from '../../components/Header'

import * as Constants from '../../constants'
import { tokens } from '../../theme'


const Device = () => {
  let theme = useTheme()
  theme = createTheme(theme, {
    components: {
      MuiTab: {
        styleOverrides: {
          root: {
            '&.Mui-selected': {
              backgroundColor: theme.palette.secondary.dark,
              color: 'black',
              '&:hover': {
                backgroundColor: theme.palette.secondary.dark,
                color: 'black',
              },
            },
          },
        },
      },
    },
  })

  const colors = tokens(theme.palette.mode)

  const [error, setError] = useState({ error: false, message: '' })
  const [success, setSuccess] = useState({ success: false, message: '' })
  const [deviceStr, setDeviceStr] = useState('')
  const [isOffline, setIsOffline] = useState(false)
  const [methods, setMethods] = useState([])
  const [currentTab, setCurrentTab] = useState(1)
  const [methodArgs, setMethodArgs] = useState([])
  const [logs, setLogs] = useState([])
  const [location, setLocation] = useState('')
  const { id } = useParams()
  const deviceIds = id.split(',')

  function handleFetchLogs() {
    if (deviceIds.length !== 1) {
      return
    }
    fetch(Constants.HOST + '/device/info', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        token: JSON.parse(localStorage.getItem('user_data')).token,
        device: deviceIds[0],
      }),
    }).then((response) => {
      if (response.status !== 400 && response.status !== 200) {
        setError({ error: true, message: 'Erro de comunicação com o servidor' })
        setSuccess({ success: false, message: '' })
      } else {
        response.json().then((data) => {
          if (data.success === false && data.message !== undefined) {
            setError({ error: true, message: data.message })
            setSuccess({ success: false, message: '' })
          } else {
            setLogs(data.logs)
          }
        })
      }
    })
  }


  function fetchLastLocation() {
    if (deviceIds.length !== 1) {
      return
    }
    fetch(Constants.HOST + '/device/lastLocation', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        token: JSON.parse(localStorage.getItem('user_data')).token,
        device: deviceIds[0],
      }),
    }).then((response) => {
      if (response.status !== 400 && response.status !== 200) {
        setError({ error: true, message: 'Erro de comunicação com o servidor' })
        setSuccess({ success: false, message: '' })
      } else {
        response.json().then((r) => {
          if (r.success === false && r.message !== undefined) {
            setError({ error: true, message: r.message })
            setSuccess({ success: false, message: '' })
          } else {
              if (r.data && r.data.created_at) {
                setLocation({data_source: r.data.data_source, latitude: r.data.latitude, longitude: r.data.longitude, created_at: r.data.created_at})
              }
          }
        })
      }
    })
  }

  function genLogsDiv() {
    let component = []
    for (const [key, value] of Object.entries(logs)) {
      // if value is array
      if (Array.isArray(value)) {
        component.push(
          <Typography variant="h6" sx={{ color: colors.text }}>
            {key}:{' '}
          </Typography>
        )
        for (let i = 0; i < value.length; i++) {
          if (typeof value[i] === 'object') {
            for (const [key2, value2] of Object.entries(value[i])) {
              component.push(
                <Typography variant="body1" sx={{ color: colors.text }}>
                  {key2}: {value2}
                </Typography>
              )
            }
          } else {
            component.push(
              <Typography variant="body1" sx={{ color: colors.text }}>
                {value[i]}
              </Typography>
            )
          }
        }
        component.push(<br />)
      } else if (typeof value === 'object') {
        component.push(
          <Typography variant="h6" sx={{ color: colors.text }}>
            {key}:{' '}
          </Typography>
        )
        for (const [key2, value2] of Object.entries(value)) {
          component.push(
            <Typography variant="body1" sx={{ color: colors.text }}>
              {key2}: {value2}
            </Typography>
          )
        }
        component.push(<br />)
      } else {
        console.log(key, value)
        component.push(
          <Typography variant="body1" sx={{ color: colors.text }}>
            {key}: {value}
          </Typography>
        )
      }
    }
    return component
  }

  function TabPanel(props) {
    const { children, value, index, ...other } = props

    return (
      <div
        role="tabpanel"
        hidden={currentTab !== index}
        id={`vertical-tabpanel-${index}`}
        aria-labelledby={`vertical-tab-${index}`}
        {...other}
      >
        {currentTab === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    )
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  }

  const handleChange = (event, newValue) => {
    setCurrentTab(newValue)
  }

  const handleFormChange = (event) => {
    if (event === undefined) return

    if (event.type === 'file')
      setMethodArgs({ [event.target.id]: event.target.files[0] })
    else setMethodArgs({ [event.target.id]: event.target.value })
  }

  function handleMethod(method) {
    let method_info = methods.find((m) => m.value === method)

    if (method_info === undefined) {
      setError({ error: true, message: 'Método não encontrado' })
      setSuccess({ success: false, message: '' })
    } else {
      fetch(Constants.HOST + '/emit', {
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body: JSON.stringify({
          token: JSON.parse(localStorage.getItem('user_data')).token,
          device_ids: deviceIds,
          method: method,
          params: methodArgs,
        }),
      }).then((response) => {
        setMethodArgs([])
        if (response.status !== 400 && response.status !== 200) {
          setError({
            error: true,
            message: 'Erro de comunicação com o servidor',
          })
          setSuccess({ success: false, message: '' })
        } else {
          response.json().then((data) => {
            if (data.success !== true) {
              setError({ error: true, message: data.message })
              setSuccess({ success: false, message: '' })
            } else {
              setError({ error: !data.success, message: data.message })
              setSuccess({ success: data.success, message: data.message })
            }
          })
          if (deviceIds.length === 1) handleFetchLogs()
        }
      })
    }
  }
  function a11yProps(index) {
    return {
      id: `vertical-tab-${index}`,
      'aria-controls': `vertical-tabpanel-${index}`,
    }
  }

  const makeButton = (data) => {
    var tabindex = methods.findIndex((m) => m.value === data.value)
    return (
      <Tab
        value={tabindex}
        label={data.name}
		key={data.name}
        {...a11yProps(tabindex)}
        sx={{ color: 'white' }}
      />
    )
  }

  const generateParamsForm = (params) => {
    if (params === undefined || params.length === 0) {
      return <></>
    } else {
      return (
        <Box sx={{ flexGrow: 1, display: 'block', marginTop: '10px' }} >
          <Typography variant="h3" component={'span'} sx={{ color: colors.primary }}>
		  	Parâmetros
		  </Typography>
		  <br />
          {params.map((param) => {
            return (
              <Box key={param.name} sx={{ flexGrow: 1, display: 'block', marginTop: '10px' }} >
                <InputLabel htmlFor={param.name} style={{ color: colors.primary }} >
                  {param.description}
                </InputLabel>
                <TextField
                  id={param.name}
                  value={methodArgs[param.name] ? methodArgs[param.name] : ''}
                  InputLabelProps={{ shrink: true }}
                  autoFocus={param.name === params[0].name}
                  key={param.name}
                  variant="outlined"
                  style={{ margin: '10px', background: '#142059' }}
                  onChange={(e) => {
                    handleFormChange(e)
                  }}
                />
              </Box>
            )
          })}
        </Box>
      )
    }
  }

  const makePanel = (data) => {
    var tabindex = methods.findIndex((m) => m.value === data.value)

    return (
      <TabPanel value={currentTab} index={tabindex} key={data.name}>
		<Typography variant="h2" component={'span'} sx={{ color: colors.text }}>
			{data.name}
		</Typography>
		<Box sx={{ flexGrow: 1, display: 'flex', marginTop: '10px' }} >
			<Typography variant="body1" component={'span'} sx={{ color: colors.text }}>
				{data.description}
			</Typography>
		</Box>
        {generateParamsForm(data.params)}
        <div
          style={{
            display: 'flex',
            justifyContent: 'right',
            alignItems: 'center',
            marginTop: '20px',
          }}
        >
          <button
            onClick={() => handleMethod(data.value)}
            variant="contained"
            style={{
              backgroundColor: colors.primary,
              border: 'none',
              padding: '10px',
              borderRadius: '5px',
            }}
          >
            Executar
          </button>
        </div>
      </TabPanel>
    )
  }

  useEffect(() => {
    if (deviceIds.length === 1) {
      // Fetch device info
      fetch(Constants.HOST + '/devices', {
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body: JSON.stringify({
          token: JSON.parse(localStorage.getItem('user_data')).token,
          device_id: deviceIds[0],
        }),
      })
        .then((response) => {
          if (response.status !== 400 && response.status !== 200) {
            setError({
              error: true,
              message: 'Erro de comunicação com o servidor',
            })
            setSuccess({ success: false, message: '' })
          } else {
            response.json().then((data) => {
              if (data.data.devices === undefined || data.data.devices.length === 0) {
                setError({
                  error: true,
                  message:
                    'Dispositivo não encontrado (Offline ou inexistente)',
                })
                setSuccess({ success: false, message: '' })
              } else {
                data = data.data
                setError({ error: false, message: '' })
                setSuccess({ success: false, message: '' })
                var json_data = data.devices[0].json_data
                  ? JSON.parse(data.devices[0].json_data)
                  : {}
                setDeviceStr(
                  json_data.manufacturer +
                  ' ' +
                  json_data.brand +
                  ' ' +
                  json_data.model +
                  ' (' +
                  data.devices[0].imei +
                  '); Proprietário: ' +
                  (data.devices[0].name !== null
                    ? data.devices[0].name
                    : 'Nenhum') +
                  '. Status: ' +
                  (data.devices[0].online ? 'Online.' : 'OFFLINE')
                )
                setIsOffline(!data.devices[0].online)
              }
            })
          }
        })
        .catch(() => {
          setError({
            error: true,
            message: 'Erro de comunicação com o servidor',
          })
          setSuccess({ success: false, message: '' })
        })
    } else {
      const deviceStr =
        'Enviando para os dispositivos selecionados (' +
        deviceIds.map((d) => String(d)).join(', ') +
        ')'
      setDeviceStr(deviceStr)
    }

    // Fetch available methods
    fetch(Constants.HOST + '/getMethods', {
      headers: { 'Content-Type': 'application/json' },
      method: 'GET',
    })
      .then((response) => {
        if (response.status !== 400 && response.status !== 200) {
          setError({
            error: true,
            message: 'Erro de comunicação com o servidor',
          })
          setSuccess({ success: false, message: '' })
        } else {
          response.json().then((data) => {
            if (data.methods === undefined || data.methods.length === 0) {
              setError({ error: true, message: 'Erro ao buscar métodos' })
              setSuccess({ success: false, message: '' })
            } else {
              setError({ error: false, message: '' })
              setSuccess({ success: false, message: '' })
              // sort methods
              data.methods.sort((a, b) => {
                if (a.name < b.name) {
                  return -1
                } else if (a.name > b.name) {
                  return 1
                } else {
                  return 0
                }
              })

              setMethods(data.methods)
            }
          })
        }
      })
      .catch(() => {
        setError({ error: true, message: 'Erro de comunicação com o servidor' })
        setSuccess({ success: false, message: '' })
      })
  }, [])


  useEffect(() => {
    console.log('fetching fetchLastLocation')
    fetchLastLocation()
  }, [])

  return (
    <Box marginLeft="20px" marginRight="20px" marginTop="0px">
      <Header title="Gerenciando dispositivo" subtitle={deviceStr} />
      {isOffline && (
        <div style={{ color: 'red', margin: '10px 0' }}>
          O dispositivo está offline. Para executar métodos, ele deve estar
          online.
        </div>
      )}
      {error.error && (
        <div style={{ color: 'red', margin: '10px 0' }}>{error.message}</div>
      )}
      {success.success && (
        <div style={{ color: 'green', margin: '10px 0' }}>
          {success.message}
        </div>
      )}

      <ThemeProvider theme={theme}>
        <Box sx={{ flexGrow: 1, display: 'flex' }} >
          <Tabs
            orientation="vertical"
            variant="scrollable"
            value={currentTab}
            onChange={handleChange}
            aria-label="Vertical tabs example"
            sx={{ borderRight: 1, borderColor: 'divider' }}
          >
            {methods.map(makeButton)}
          </Tabs>
          {methods.map(makePanel)}
        </Box>
      </ThemeProvider>

      {logs && (
        <div style={{ marginTop: '20px', marginBottom: '10px' }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
            }}
          >
            <h4 style={{ color: colors.primary }}>Logs</h4>
            <IconButton
              onClick={() => {
                handleFetchLogs()
              }}
            >
              <RefreshIcon />
            </IconButton>
          </div>
          <Box
            sx={{
              width: '100%',
              overflow: 'auto',
              maxHeight: '200px',
              bgcolor: 'background.paper',
            }}
          >
            {genLogsDiv()}
          </Box>
        </div>
      )}

      {location && (
        <React.Fragment>
          <Typography variant="h3" sx={{ color: colors.primary }}>
            Última localização
          </Typography>
          <Typography variant="body1" sx={{ color: colors.text, mt: 1 }}>
            {location.data_source} - {location.created_at}
          </Typography>
            <div style={{ marginTop: '10px' }}>
              <iframe
                width="90%"
                height="300"
                title="map"
                src={`https://maps.google.com/maps?q=${location.latitude},${location.longitude}&hl=es&z=14&output=embed`}
              ></iframe>
              <br />
              <small>
                <a
                  href={`https://maps.google.com/maps?q=${location}&z=14`}
                  target="_blank"
                >
                  Ver mapa ampliado
                </a>
              </small>
            </div>
            </React.Fragment>
      )}
    </Box>
  )
}

export default Device
